import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const WHATSAPP_DISPLAY = "11 99457-6696";
export const waLink = (text = "Olá! Gostaria de solicitar um orçamento de limpeza.") =>
  `https://wa.me/5511994576696?text=${encodeURIComponent(text)}`;

export const SERVICE_LABEL = {
  comercial: "Limpeza comercial",
  residencial: "Faxina residencial",
  pos_obra: "Limpeza pós-obra",
  diarista: "Diarista / Faxineira",
};
export const DIRT_LABEL = { leve: "Leve", media: "Média", pesada: "Pesada" };

export const adminApi = () =>
  axios.create({ baseURL: API, headers: { Authorization: `Bearer ${localStorage.getItem("lrsp_token") || ""}` } });

export const formatErr = (detail) => {
  if (detail == null) return "Algo deu errado. Tente novamente.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || "").filter(Boolean).join(" ");
  return detail?.msg || String(detail);
};

let lenisRef = null;
export const setLenis = (l) => { lenisRef = l; };
export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (lenisRef) lenisRef.scrollTo(el, { offset: -70, duration: 1.6 });
  else el.scrollIntoView({ behavior: "smooth" });
};
